<template>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-8">
        <h1 id="proy-code" class="pull-left">Compras</h1>
      </div>
      <div class="col-xs-4">
            <button class="btn btn-app pull-right bg-red" v-if="puedoCrear()" @click="crear()">
              <i class="fa fa-plus"></i> Nuevo
            </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 form-group" v-if="!codigo_proyecto">
        <select class="form-control" v-model="filtros.codigo_proyecto" @change="filtrarDatos(1, 'general')">
          <option :value="null">-- Seleccione --</option>
          <option v-for="proyecto in $store.state.apiData.proyectos" :value="proyecto.codigo_proyecto">{{ proyecto.codigo_proyecto }}</option>
        </select>          
      </div>         
      <div class="col-md-6 form-group">
          <div class="input-group">
            <input type="text" name="search" v-model="filtros.buscar" @keyup.enter="filtrarDatos(1, 'general')" class="form-control" placeholder="Buscar..." :disabled="!$store.state.online">
            <div class="input-group-btn">
              <button type="button" class="btn btn-default" @click="filtrarDatos(1, 'general')" :disabled="!$store.state.online">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>        
      </div>
    </div>

    <div class="row">
        <div class="col-md-12 tab-container">
            <div class="nav-tabs-custom">
                <ul class="nav nav-tabs pull-left">
                  <li :class="{'active': solapaActual === 'enprogreso'}" v-if="solapa_enprogreso.mostrar"><a href="#enprogreso" data-toggle="tab" aria-expanded="true" @click="cambiarSolapa('enprogreso')">En Progreso</a></li>
                  <li :class="{'active': solapaActual === 'completado'}" v-if="solapa_completado.mostrar"><a href="#completado" data-toggle="tab" aria-expanded="false" @click="cambiarSolapa('completado')">Completados</a></li>
                  <li :class="{'active': solapaActual === 'archivo'}" v-if="solapa_archivo.mostrar"><a href="#archivo" data-toggle="tab" aria-expanded="false" @click="cambiarSolapa('archivo')">Archivo</a></li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane" :class="{'active' : solapaActual === 'enprogreso'}" v-if="solapa_enprogreso.mostrar" id="enprogreso">
                      <div class="clearfix"></div>
                      <h3 v-if="tabla_solicitados.mostrar">Solicitados</h3>
                      <tabla-compra v-if="tabla_solicitados.mostrar" :solapa="'enprogreso'" :tabla="'solicitados'" :data="paginarDatos('solicitados')" :total="solicitados.length" :regPagina="filtros._limit" :paginaActual="tabla_solicitados.pagina" @compras:filtar="filtrarDatos" @compras:acciones="acciones" :cargando="tabla_solicitados.cargando"></tabla-compra>

                      <h3 v-if="tabla_aprobados.mostrar">Aprobados</h3>
                      <tabla-compra v-if="tabla_aprobados.mostrar" :solapa="'enprogreso'" :tabla="'aprobados'" :data="paginarDatos('aprobados')" :total="aprobados.length" :regPagina="filtros._limit" :paginaActual="tabla_aprobados.pagina" @compras:filtar="filtrarDatos" @compras:acciones="acciones" :cargando="tabla_aprobados.cargando"></tabla-compra>

                      <h3 v-if="tabla_comprados.mostrar">Comprados</h3>
                      <tabla-compra v-if="tabla_comprados.mostrar" :solapa="'enprogreso'" :tabla="'comprados'" :data="paginarDatos('comprados')" :total="comprados.length" :regPagina="filtros._limit" :paginaActual="tabla_comprados.pagina" @compras:filtar="filtrarDatos" @compras:acciones="acciones" :cargando="tabla_comprados.cargando"></tabla-compra>
                    </div>
                    <div class="tab-pane" :class="{'active' : solapaActual === 'completado'}" v-if="solapa_completado.mostrar" id="completado">
                      <div class="clearfix"></div>
                      <tabla-compra v-if="tabla_completado.mostrar" :solapa="'completado'" :tabla="'completado'" :data="completados" :total="tabla_completado.total" :regPagina="filtros._limit" :paginaActual="tabla_completado.pagina" @compras:filtar="filtrarDatos" @compras:acciones="acciones" :cargando="tabla_completado.cargando"></tabla-compra>
                    </div>
                    <div class="tab-pane" :class="{'active' : solapaActual === 'archivo'}" v-if="solapa_archivo.mostrar" id="archivo">
                      <div class="clearfix"></div>
                      <tabla-compra v-if="tabla_archivo.mostrar" :solapa="'archivo'" :tabla="'archivo'" :data="archivados" :total="tabla_archivo.total" :regPagina="filtros._limit" :paginaActual="tabla_archivo.pagina" @compras:filtar="filtrarDatos" @compras:acciones="acciones"  :cargando="tabla_archivo.cargando"></tabla-compra>
                    </div>
                </div>
              </div>
              <!-- /.tab-content -->
          </div>        
    </div>
  </div>
  <a-m-compra :mostrar="vistaAM.mostrar" :item="vistaAM.item" :editar="vistaAM.accion !== 'ver'" :accion="this.vistaAM.accion" @am-compra:cerrar="onCerrarVistaAM" :cambiarCP="codigo_proyecto === null"></a-m-compra>  
</div>
</template>
<script>
import api from '../../../api'
import {toQueryString} from '../../../filters/object'
import {pad} from '../../../filters/string'
import AMCompra from './AMCompra'
import TablaCompra from './TablaCompra'
import _ from 'lodash'
import { EventBus } from '../../../core/event-bus.js'
import db from '../../../core/pouchdb'

export default {
  name: 'Compras',
  components: {
    TablaCompra,
    AMCompra
  },
  filters: {
    toQueryString,
    pad
  },
  props: {
    codigo_proyecto: {
      type: String,
      default () {
        return null
      }
    },
    tabla: {
      type: String,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      mostrarTabsAdic: false,
      vistaAM: {
        mostrar: false,
        item: null,
        accion: 'crear'
      },
      solapa_enprogreso: {
        mostrar: false,
        data: [],
        cargado: false,
        cargando: false
      },
      solapa_completado: {
        mostrar: false
      },
      solapa_archivo: {
        mostrar: false
      },
      tabla_completado: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      tabla_solicitados: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      tabla_aprobados: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      tabla_comprados: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      tabla_archivo: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      solapaActual: 'enprogreso',
      filtros: {
        codigo_proyecto: this.codigo_proyecto,
        _sort: 'createdAt:desc',
        _limit: 50,
        buscar: null,
        buscar_local: null
      },
      errores: null,
      loading: true,
      rolesCrear: ['root', 'manager', 'jefe_de_obras', 'coordinador', 'empleado', 'supervisor']
    }
  },
  mounted () {
    let vm = this

    EventBus.$on('sync-completed', () => {
      if (vm.solapaActual === 'enprogreso') {
        vm.getEnProgreso()
      } else {
        vm.filtrarDatos(1)
      }
    })

    if (vm.$store.state.loaded) {
      vm.init()
    } else {
      EventBus.$on('datos-cargados', () => {
        vm.init()
      })
    }
  },
  destroyed () {
    EventBus.$off('sync-completed')
    EventBus.$off('datos-cargados')
  },
  computed: {
    solicitados: function () {
      let _filtros = {
        estado: 'Pendiente',
        archivar: false,
        completado: false
      }

      if (this.filtros.buscar_local) {
        _filtros.pedido_id = parseInt(this.filtros.buscar_local)
      }
      if (this.filtros.codigo_proyecto) {
        _filtros.codigo_proyecto = this.filtros.codigo_proyecto
      }
      return _.orderBy(_.filter(this.solapa_enprogreso.data, _filtros), 'createdAt', 'desc')
    },
    aprobados: function () {
      let _filtros = {
        estado: 'Aprobado',
        archivar: false,
        completado: false
      }

      if (this.filtros.buscar_local) {
        _filtros.pedido_id = parseInt(this.filtros.buscar_local)
      }
      if (this.filtros.codigo_proyecto) {
        _filtros.codigo_proyecto = this.filtros.codigo_proyecto
      }
      return _.orderBy(_.filter(this.solapa_enprogreso.data, _filtros), 'createdAt', 'desc')
    },
    comprados: function () {
      let _filtros = {
        estado: 'Comprado',
        archivar: false,
        completado: false
      }

      if (this.filtros.buscar_local) {
        _filtros.pedido_id = parseInt(this.filtros.buscar_local)
      }
      if (this.filtros.codigo_proyecto) {
        _filtros.codigo_proyecto = this.filtros.codigo_proyecto
      }

      return _.orderBy(_.filter(this.solapa_enprogreso.data, _filtros), 'createdAt', 'desc')
    },
    archivados: function () {
      let _filtros = { archivar: true }

      return _.filter(this.tabla_archivo.data, _filtros)
    },
    completados: function () {
      let _filtros = { archivar: false, completado: true }

      return _.orderBy(_.filter(this.tabla_completado.data, _filtros), 'createdAt', 'desc')
    }
  },
  methods: {
    init () {
      let vm = this
      if (vm.tabla) {
        switch (vm.tabla) {
          case 'completado':
            vm.solapaActual = 'completado'
            vm['solapa_' + vm.tabla].mostrar = true
            vm['tabla_' + vm.tabla].mostrar = true
            vm.getListado(vm.solapaActual)
            break
          case 'archivo':
            vm.solapaActual = 'archivo'
            vm['solapa_' + vm.tabla].mostrar = true
            vm['tabla_' + vm.tabla].mostrar = true
            vm.getListado(vm.solapaActual)
            break
          case 'enprogreso':
            vm.solapaActual = 'enprogreso'
            vm['solapa_enprogreso'].mostrar = true
            vm['tabla_solicitados'].mostrar = true
            vm['tabla_aprobados'].mostrar = true
            vm['tabla_comprados'].mostrar = true
            vm.getEnProgreso()
            break
          default:
            vm.solapaActual = 'enprogreso'
            vm['solapa_enprogreso'].mostrar = true
            vm['tabla_' + vm.tabla].mostrar = true
            vm.getEnProgreso()
            break
        }
      } else {
        vm.solapa_enprogreso.mostrar = true
        vm.solapa_completado.mostrar = true
        vm.solapa_archivo.mostrar = true
        vm.tabla_solicitados.mostrar = true
        vm.tabla_aprobados.mostrar = true
        vm.tabla_comprados.mostrar = true
        vm.getEnProgreso()
      }
    },
    paginarDatos (tabla) {
      let vm = this
      let start = (vm['tabla_' + tabla].pagina - 1) * this.filtros._limit
      return vm[tabla].slice(start, start + this.filtros._limit)
    },
    dataActualizada (data, solapa) {
      let vm = this
      let _filters = {}

      if (vm.codigo_proyecto) {
        _filters.codigo_proyecto = vm.codigo_proyecto
      } else {
        _filters.solicitado_user = vm.$store.state.user.username
      }

      if (!vm.$store.state.online) {
        if (solapa === 'enprogreso') {
          return db.findByFilters('compras', _filters).then(dbData => {
            return _.unionBy(dbData.docs, data, 'id')
          })
        } else {
          let _pagina = vm['tabla_' + solapa].pagina
          return vm.combinarDataApiLocalID(data).then((resData) => {
            if (_pagina === 1) {
              switch (solapa) {
                case 'completado':
                  _filters.completado = true
                  break
                case 'archivo':
                  _filters.archivar = true
                  break
              }

              return db.findByFilters('compras', _filters).then(dbData => {
                return _.unionBy(dbData.docs, resData)
              })
            }
            return Promise.resolve(resData)
          })
        }
      } else {
        return Promise.resolve(data)
      }
    },
    combinarDataApiLocalID (dataApi) {
      let _ids = []
      for (let i = 0; i < dataApi.length; i++) {
        _ids.push(dataApi[i].id)
      }
      if (_ids.length > 0) {
        return db.findByIds(_ids, 'compras').then(dbData => {
          return _.unionBy(dbData.docs, dataApi, 'id')
        })
      } else {
        return Promise.resolve(dataApi)
      }
    },
    crear () {
      this.vistaAM.item = _.assign({
        pedido_id: this.$options.filters.pad(Date.now().toString(), 13),
        codigo_proyecto: this.codigo_proyecto,
        items: [{
          item_descripcion: null,
          qty: 1,
          unidad_medida: null,
          solicitado_user: this.$store.state.user.username,
          validado_user: null,
          comprado_user: null,
          id_orden_compra: null,
          completado: false,
          archivar: false,
          estado: 'Pendiente'
        }]
      })
      this.vistaAM.accion = 'crear'
      this.vistaAM.mostrar = true
    },
    filtrarDatos (pagina, solapa, tabla) {
      let vm = this
      let _solapa = solapa || this.solapaActual

      switch (_solapa) {
        case 'enprogreso':
          vm['tabla_' + tabla].pagina = pagina
          break
        case 'completado':
          vm.tabla_completado.pagina = pagina
          break
        case 'archivo':
          vm.tabla_archivo.pagina = pagina
          // vm.getListado(_solapa)
          break
        default:
          vm.filtros.buscar_local = vm.filtros.buscar
          vm.tabla_solicitados.pagina = pagina
          vm.tabla_aprobados.pagina = pagina
          vm.tabla_comprados.pagina = pagina
          vm.tabla_completado.pagina = pagina
          vm.tabla_archivo.pagina = pagina
          break
      }
      if (this.solapaActual !== 'enprogreso') {
        vm.getListado(this.solapaActual)
      }
    },
    getEnProgreso () {
      let vm = this
      let _filtros = {
        completado: false,
        archivar: false,
        _start: 0,
        _sort: 'createdAt:desc'
      }

      if (vm.codigo_proyecto) {
        _filtros.codigo_proyecto = vm.codigo_proyecto
      } else {
        let _proyectos = this.$store.getters.getProyectosUsuario()
        if (_proyectos.length > 0) {
          let _codigos = []
          _.forEach(this.$store.state.apiData.proyectos, (value, key) => {
            _codigos.push(value.codigo_proyecto)
          })
          _filtros.codigo_proyecto = _codigos
        }
      }

      vm.solapa_enprogreso.cargando = true
      vm.tabla_solicitados.cargando = vm.tabla_comprados.cargando = vm.tabla_aprobados.cargando = true

      EventBus.$emit('tabla_solicitados:loading', true)
      api.getCompras(this.$options.filters.toQueryString(_filtros)).then(resp => {
        vm.dataActualizada(resp.data, 'enprogreso').then(data => {
          vm.solapa_enprogreso.data = data
          vm.solapa_enprogreso.total = resp.total
          vm.solapa_enprogreso.cargando = false
          vm.solapa_enprogreso.cargado = true
          vm.tabla_solicitados.cargando = vm.tabla_comprados.cargando = vm.tabla_aprobados.cargando = false
        })
      }, error => {
        vm.errores = error.message
        vm.dataActualizada([], 'enprogreso').then(data => {
          vm.solapa_enprogreso.data = data
          vm.solapa_enprogreso.total = data.length
          vm.solapa_enprogreso.cargando = false
          vm.solapa_enprogreso.cargado = true
          vm.tabla_solicitados.cargando = vm.tabla_comprados.cargando = vm.tabla_aprobados.cargando = false
        })
      })
    },
    getListado (solapa) {
      let vm = this
      let filtrosBuscar = {}

      if (vm.filtros.buscar) {
        filtrosBuscar.pedido_id = vm.filtros.buscar
      }

      if (vm.filtros.codigo_proyecto) {
        filtrosBuscar.codigo_proyecto = vm.filtros.codigo_proyecto
      } else {
        let _proyectos = this.$store.getters.getProyectosUsuario()
        if (_proyectos.length > 0) {
          let _codigos = []
          _.forEach(this.$store.state.apiData.proyectos, (value, key) => {
            _codigos.push(value.codigo_proyecto)
          })
          filtrosBuscar.codigo_proyecto = _codigos
        }
      }

      switch (solapa) {
        case 'completado':
          filtrosBuscar.completado = true
          break
        case 'archivo':
          filtrosBuscar.archivar = true
          break
      }

      let _pagina = vm['tabla_' + solapa].pagina

      filtrosBuscar._start = (_pagina - 1) * this.filtros._limit

      let _filtros = _.assign({}, vm.filtros, filtrosBuscar)

      delete _filtros.buscar
      delete _filtros.buscar_local

      vm['tabla_' + solapa].cargando = true
      api.getCompras(this.$options.filters.toQueryString(_filtros)).then(resp => {
        vm.dataActualizada(resp.data, solapa).then(data => {
          vm['tabla_' + solapa].data = data
          vm['tabla_' + solapa].total = resp.total
          vm['tabla_' + solapa].cargando = false
        })
      }, error => {
        vm.dataActualizada([], solapa).then(data => {
          vm['tabla_' + solapa].data = data
          vm['tabla_' + solapa].total = data.length
          vm['tabla_' + solapa].cargando = false
        })
        vm.errores = error.message
      })
    },
    cambiarSolapa (solapa) {
      this.solapaActual = solapa
      if (solapa !== 'enprogreso') {
        this['tabla_' + solapa].mostrar = true
        this.getListado(solapa)
      }
    },
    puedoCrear () {
      return this.rolesCrear.indexOf(this.$store.state.user.role.type) > -1
    },
    editar (item) {
      this.vistaAM.item = _.assign({
        pedido_id: item.pedido_id,
        codigo_proyecto: item.codigo_proyecto,
        items: []
      })
      this.tabla_solicitados.index_item_actual = item.index_solicitado
      this.vistaAM.item.items.push(_.cloneDeep(item))
      this.vistaAM.accion = 'editar'
      this.vistaAM.mostrar = true
    },
    ver (item) {
      this.vistaAM.item = _.cloneDeep(item)
      this.vistaAM.item.fecha = this.vistaAM.item.fecha.replace('Z', '')
      this.vistaAM.accion = 'ver'
      this.vistaAM.mostrar = true
    },
    onCerrarVistaAM (data) {
      this.vistaAM.mostrar = false
      // this.vistaAM.item = null
      if (data) {
        this.$store.commit('SHOW_SUCCESS_ALERT', {
          message: 'La operación finalizó con éxito'
        })
        if (this.vistaAM.accion === 'editar') {
          this.reemplazarItemEnPreparacion(data[0]._id, data[0])
          this.tabla_solicitados.index_item_actual = -1
        } else {
          data.forEach((item) => {
            this.solapa_enprogreso.data.push(item)
            this.enviarEmails(item, 'Pendiente')
          })
        }
      }
    },
    archivar (item, tabla) {
      let vm = this
      if (vm.$store.state.online) {
        vm['tabla_' + tabla].cargando = true
        item.completado = false
        item.archivar = true
        item.estado = 'Archivado'
        api.saveCompras(item)
          .then(vm.accionOk, vm.accionError)
          .then(data => {
            vm['tabla_' + tabla].cargando = false
            vm.getListado(vm.solapaActual)
          })
      } else {
        alert('Para archivar el registro, debe estar online')
      }
    },
    aprobar (item, tabla) {
      let vm = this
      item.validado_user = this.$store.state.user.username
      item.estado = 'Aprobado'
      vm['tabla_' + tabla].cargando = true
      if (vm.$store.state.online) {
        api.saveCompras(item)
          .then(vm.accionOk, vm.accionError)
          .then(() => {
            vm.enviarEmails(item, 'Aprobado')
            vm['tabla_' + tabla].cargando = false
          })
      } else {
        item.accion_email = 'Aprobado'
        db.save(item, 'compras', 'edit').then(function (response) {
          item._rev = response.rev
          vm['tabla_' + tabla].cargando = false
          return vm.accionOk(item)
        }, vm.accionError)
      }
    },
    comprar (item, tabla) {
      let vm = this
      if (!item.id_orden_compra) {
        alert('Ingrese una OC')
        return false
      }
      item.comprado_user = this.$store.state.user.username
      item.estado = 'Comprado'
      vm['tabla_' + tabla].cargando = true
      if (vm.$store.state.online) {
        api.saveCompras(item)
          .then(vm.accionOk, vm.accionError)
          .then(() => {
            vm.enviarEmails(item, 'Comprado')
            vm['tabla_' + tabla].cargando = false
          })
      } else {
        item.accion_email = 'Comprado'
        db.save(item, 'compras', 'edit').then(function (response) {
          item._rev = response.rev
          vm['tabla_' + tabla].cargando = false
          return vm.accionOk(item)
        }, vm.accionError)
      }
    },
    cancelar (item, tabla) {
      let vm = this
      if (!item.id_orden_compra) {
        alert('Ingrese una OC')
        return false
      }
      item.id_orden_compra = null
      item.comprado_user = null
      item.estado = 'Aprobado'
      vm['tabla_' + tabla].cargando = true
      if (vm.$store.state.online) {
        api.saveCompras(item)
          .then(vm.accionOk, vm.accionError)
          .then(() => {
            vm.enviarEmails(item, 'Rechazado')
            vm['tabla_' + tabla].cargando = false
          })
      } else {
        db.save(item, 'compras', 'edit').then(function (response) {
          item._rev = response.rev
          vm['tabla_' + tabla].cargando = false
          return vm.accionOk(item)
        }, vm.accionError)
      }
    },
    completar (item, estado, index, tabla) {
      let vm = this
      item.completado = true
      item.archivar = false
      item.estado = estado
      vm['tabla_' + tabla].cargando = true
      if (vm.$store.state.online) {
        api.saveCompras(item)
          .then(vm.accionOk, vm.accionError)
          .then(() => {
            if (estado === 'Recibido') {
              vm.enviarEmails(item, 'Completado')
            } else {
              vm.enviarEmails(item, 'Rechazado')
            }
            vm['tabla_' + tabla].cargando = false
          })
      } else {
        if (estado === 'Recibido') {
          item.accion_email = 'Completado'
        }

        db.save(item, 'compras', 'edit').then(function (response) {
          item._rev = response.rev
          vm['tabla_' + tabla].cargando = false
          return vm.accionOk(item)
        }, vm.accionError)
      }
    },
    pendiente (item, index, tabla) {
      let vm = this
      if (vm.$store.state.online) {
        let _item = _.assign({}, item, {
          completado: false,
          archivar: false,
          estado: 'Pendiente'
        })
        vm['tabla_' + tabla].cargando = true
        api.saveCompras(_item)
          .then(vm.accionOk, vm.accionError)
          .then(data => {
            vm.reemplazarItemEnPreparacion(_item._id, data)
            vm['tabla_' + tabla].cargando = false
            vm.getListado(vm.solapaActual)
          })
      } else {
        alert('Para desarchivar el registro, debe estar online')
      }
    },
    acciones (accion, item, index, tabla, solapa) {
      let vm = this
      switch (accion) {
        case 'ver':
          vm.ver(item)
          break
        case 'editar':
          vm.editar(item)
          break
        case 'aprobar':
          vm.aprobar(item, tabla)
          break
        case 'comprar':
          vm.comprar(item, tabla)
          break
        case 'cancelar':
          vm.cancelar(item, tabla)
          break
        case 'completar':
          vm.completar(item, 'Recibido', index, tabla)
          break
        case 'rechazar':
          vm.completar(item, 'Rechazado', index, tabla)
          break
        case 'archivar':
          vm.archivar(item, tabla)
          break
        case 'pendiente':
          vm.pendiente(item, index, tabla)
          break
      }
    },
    accionOk (data) {
      this.$store.commit('SHOW_SUCCESS_ALERT', {
        message: 'La operación finalizó con éxito'
      })
      return data
    },
    accionError (error) {
      this.$store.commit('SHOW_DANGER_ALERT', {
        message: error.message
      })
    },
    reemplazarItemEnPreparacion (id, item) {
      let vm = this
      let index = _.findIndex(vm.solapa_enprogreso.data, function (o) { return o._id === id })
      if (index > -1) {
        this.$set(vm.solapa_enprogreso.data, index, item)
      } else {
        vm.solapa_enprogreso.data.push(item)
      }
    },
    enviarEmails (compra, accion) {
      if (this.$store.state.online) {
        EventBus.$emit('enviar-email-compras', compra, accion)
      }
    }
  }
}
</script>
<style scoped>
  h1#proy-code {
    margin-top: 0;
  }
  .tab-container{
    padding-top: 20px
  }
</style>


// WEBPACK FOOTER //
// src/components/views/compras/Index.vue